import { useMemo, useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  withStyles,
} from "@material-ui/core";
import ActivityDatePicker from "./ActivityDatePicker";
import { useDispatch } from "react-redux";
import { postSnackMessage } from "core/actions";
import { generatePdfReport } from "./actions";

const styles = (theme) => ({
  spacing: {
    margin: "10px 0px",
  },
  sofia: {
    fontSize: 16,
    fontFamily: "Sofia !important",
    "& .MuiFormControlLabel-label": {
      fontSize: 16,
      fontFamily: "Sofia !important",
    },
  },
  searchBox: {
    margin: "10px 0px",
    flexBasis: "100%",
    flex: "1 1 auto",
    "& label, input": {
      fontSize: 16,
      fontFamily: "Sofia",
    },
  },
});

function ExtendedReport({ classes, userAccounts }) {
  const [companyFilterType, setCompanyFilterType] = useState(
    userAccounts?.[0]?.accountId ?? 0
  );
  const [selectedMessageGroup, setSelectedMessageGroup] = useState(-1);
  const dispatch = useDispatch();
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const userMessageGroups = useMemo(() => {
    const account = userAccounts.find(
      (acc) => acc.accountId === companyFilterType
    );
    if (account) {
      return (account?.messageGroups ?? []).filter((mg) => {
        return mg.userDefault === "N";
      });
    }
    return [];
  }, [userAccounts, companyFilterType]);
  if (userAccounts.length <= 0) {
    return null;
  }
  const handleGeneratePdfReport = async () => {
    let minDate = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);
    let maxDate = new Date(new Date());
    if (startTime !== null) {
      minDate = new Date(startTime);
      minDate.setHours(0, 0, 0, 0);
    }
    if (endTime !== null) {
      maxDate = new Date(endTime);
      maxDate.setHours(24, 0, 0, 0);
    }

    // console.log(Math.floor((maxDate - minDate) / (1000 * 60 * 60 * 24)));
    if (Math.floor((maxDate - minDate) / (1000 * 60 * 60 * 24)) > 31) {
      dispatch(
        postSnackMessage("error", "", "PDF export can only load max of 31 days")
      );
      return;
    }
    dispatch(
      generatePdfReport(
        "No Filters",
        undefined,
        minDate,
        maxDate,
        undefined,
        [],
        "N",
        selectedMessageGroup
      )
    );
  };
  return (
    <div>
      <div className={classes.spacing}>
        <FormControl style={{ width: "100%" }} variant="outlined">
          <InputLabel id="account-select-report" style={{ background: "#fff" }}>
            Account
          </InputLabel>
          <Select
            labelId="account-select-report"
            value={companyFilterType}
            onChange={(event) => {
              setCompanyFilterType(event.target.value);
              setSelectedMessageGroup(-1);
            }}
          >
            {userAccounts.map((filterAccount) => (
              <MenuItem
                className={classes.sofia}
                key={filterAccount.accountId}
                value={filterAccount.accountId}
              >
                {filterAccount.accountName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className={classes.spacing}>
        <FormControl style={{ width: "100%" }} variant="outlined">
          <InputLabel
            id="message-group-select-report"
            style={{ background: "#fff" }}
          >
            Message Group
          </InputLabel>
          <Select
            labelId="message-group-select-report"
            value={selectedMessageGroup}
            onChange={(event) => {
              setSelectedMessageGroup(event.target.value);
            }}
            input={<OutlinedInput style={{ width: "100%" }} />}
          >
            <MenuItem className={classes.sofia} value={-1}>
              Select Message Group
            </MenuItem>

            {userMessageGroups.map((messageGroup) => (
              <MenuItem
                className={classes.sofia}
                key={messageGroup.messageGroupId}
                value={messageGroup.messageGroupId}
              >
                {messageGroup.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <ActivityDatePicker
        classes={{
          searchBox: classes.searchBox,
        }}
        startTime={startTime}
        endTime={endTime}
        isActivityPage={false}
        setStartTime={(value) => {
          setStartTime(value !== null ? value.toJSDate() : null);
        }}
        setEndTime={(value) => {
          setEndTime(value !== null ? value.toJSDate() : null);
        }}
      />
      <Button
        disabled={selectedMessageGroup === -1}
        onClick={handleGeneratePdfReport}
      >
        Export PDF Report
      </Button>
    </div>
  );
}

export default withStyles(styles)(ExtendedReport);
